import React from 'react'
import classnames from 'classnames'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import IconButton from '@material-ui/core/IconButton'
import Collapse from '@material-ui/core/Collapse'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import ButtonBase from '@material-ui/core/ButtonBase'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import CircularProgress from '@material-ui/core/CircularProgress'

import CommentIcon from '@material-ui/icons/Comment'
import ThumbUpIcon from '@material-ui/icons/ThumbUp'
import ThumbDownIcon from '@material-ui/icons/ThumbDown'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import withStyles from '@material-ui/core/styles/withStyles'

import { TitleGrid, RenjuBoardCard, RenjuBoard, ControlCard, Word } from '../../../containers'
import { PuzzleMenuItems } from '../containers'
import { strToRenjuBoardCard, makePath } from '../../../lib'
import { Link, useHistory } from 'react-router-dom'
import TimeAgo from 'react-timeago'
import jaStrings from 'react-timeago/lib/language-strings/ja'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import dateformat from 'dateformat'
import { WID, getWord } from '../../../constants/Language';
import { useState } from 'react'
import { useEffect } from 'react'
import { useContext } from 'react'
import { SettingsContext } from '../../../Parts/Settings'
import { useDispatch } from 'react-redux'
import { types } from '../../../constants/ActionTypes'
 
const formatter = buildFormatter(jaStrings)

const styles = theme => ({
  customHeaderTitle: {
  },
  title: {
    marginBottom: theme.spacing.unit,
  },
  authorAndDateTimeBox: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  level: {
    marginTop: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.grey[800]
  },
  datetime: {
    color: theme.palette.grey[500],
    marginRight: theme.spacing.unit * 2,
  },
  authorName: {
    color: theme.palette.grey[500]
  },
  avatar: {
    width: 56,
    height: 56,
    marginRight: theme.spacing.unit,
  },
  turnAndTypeBox: {
    display: 'flex',
    justifyContent: 'center'
  },
  turn: {
    marginRight: theme.spacing.unit * 2,
  },
  goodNumber: {
    color: theme.palette.grey[500],
    marginRight: theme.spacing.unit * 2,
  },
  badNumber: {
    color: theme.palette.grey[500],
    marginRight: theme.spacing.unit * 2,
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
    [theme.breakpoints.up('sm')]: {
      marginRight: -8,
    },
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  commentBox: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 3,
  },
  commentAvatar: {
    width: 40,
    height: 40,
    marginRight: theme.spacing.unit,
  },
  tagBox: {
    marginRight: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  chip: {
    marginLeft: theme.spacing.unit,
  },
  thumbIcon: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    color: theme.palette.grey[500],
  },
  resultBox: {
    padding: `${theme.spacing.unit * 10}px 0`,
    backgroundColor: 'white',
    width: '100%',
    maxWidth: 680,
    margin: '0 auto',
  },
  evaluationIcon: {
    marginRight: theme.spacing.unit,
  },
  commentIcon: {
    color: theme.palette.grey[500],
    marginRight: theme.spacing.unit,
  },
  commentsLength: {
    color: theme.palette.grey[500]
  },
  flexCenterBox: {
    display: 'flex',
    justifyContent: 'center',
  },
  renjuBoardCardBox: {
    marginBottom: theme.spacing.unit * 10,
  }
})

const PuzzleViewer = (props) => {
  var title, thumbUpButtonProp, thumbDownButtonProp, commentsLength

  const { classes, theme, id, bid, record, comment, isAppendedBoard, auth0, user, openConfirmDialog, confirmType, confirmParams, deleted, ready, handleClickThumbUp, handleClickThumbDown, handleAnswer, handleClickTag, commentProps, confirmDialogProps } = props

  const [isInitialized, setIsInitialized] = useState(false)
  const [expanded, setExpanded] = useState(false)

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const dispatch = useDispatch()

  const history = useHistory()

  useEffect(() => {
    if (!isInitialized) {
      window.scrollTo(0, 0)
      dispatch({ type: types.puzzleViewer.INITIALIZE })
      setIsInitialized(true)
    }
  }, [isInitialized])

  useEffect(() => {
    if (auth0) {
      props.init(props.records)
    }
  }, [auth0])

  if (record) {
    title = record.title === '' ? 'untitled' : record.title
    thumbUpButtonProp = record.isSelectedGood === true ?
      { style: { color: theme.palette.primary.main } } : { style: { color: theme.palette.grey[500] } }
    thumbDownButtonProp = record.isSelectedBad === true ?
      { style: { color: theme.palette.primary.main } } : { style: { color: theme.palette.grey[500] } }
    if (record.comments && record.comments.length > 0) {
      commentsLength = record.comments[0].comment ? record.comments.length : record.comments.length - 1
    }
    else {
      commentsLength = 0
    }
  }

  return (
    <TitleGrid titleType='puzzle' menuItems={<PuzzleMenuItems/>}>
      <Grid item md={12} xs={12}>
        {deleted ? (
          <div className={classes.resultBox}>
            <Typography variant='title' align='center' style={{marginBottom: theme.spacing.unit * 2}}>
              <Word wid={WID.PUZZLE_VIEWER.FINISH_DELETE}/>
            </Typography>
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <Button
                component={Link}
                to={makePath('/puzzle', language)}
                variant="text"
                color="primary"
                className={classes.button}
              >
                <Word wid={WID.PUZZLE_VIEWER.GO_TO_PUZZLE_LIST_BUTTON}/>
              </Button>
            </div>
          </div>
        ) :
        bid >= 0 && record.author ? (
          <div className={classes.renjuBoardCardBox}>
          <RenjuBoardCard
            bid={bid}
            isVisibleEditModeMenu={false}
            isVisibleOperationMenu={false}
            isVisiblePuzzleSetControl={false}
            isVisibleGameInfo={false}
            avatar={
              <Avatar
                alt={record.author.displayName}
                src={record.author.photoURL}
                className={classes.avatar}
                onClick={() => history.push(makePath(`/user/${record.author.userName}`, language))}/>
            }
            customHeaderTitle={
              <Typography variant='title' className={classes.title}>{title}</Typography>
            }
            subheader={
              <React.Fragment>
                <Typography className={classes.authorName}>{record.author.displayName}</Typography>
                <div style={{display: 'flex', alignItems: 'center'}}>
                  {record.datetime < Date.now() ? (
                    <Typography className={classes.datetime}><TimeAgo date={record.datetime} formatter={formatter}/></Typography>
                  ) : (
                    <Typography color='inherit' className={classes.datetime}>
                      <Word wid={WID.PUZZLE_VIEWER.RELEASE_DATE_LABEL}/>: {dateformat(record.datetime, 'yyyy/m/d HH:MM')}</Typography>
                  )}
                  {record.isAuthor && (
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <ButtonBase component={Link} to={makePath(`/puzzle/register/${id}`, language)}>
                        <Typography color='primary' style={{marginRight: theme.spacing.unit}}>
                          <Word wid={WID.PUZZLE_VIEWER.EDIT_BUTTON}/>
                        </Typography>
                      </ButtonBase>
                      <ButtonBase onClick={confirmDialogProps.handleOpen('puzzle', { id })}>
                        <Typography color='primary'>
                          <Word wid={WID.PUZZLE_VIEWER.DELETE_BUTTON}/>
                        </Typography>
                      </ButtonBase>
                    </div>
                  )}
                </div>
              </React.Fragment>
            }
            customContent={
              <React.Fragment>
                {record.tags && record.tags.length > 0 && (
                  <div className={classes.tagBox}>
                    <Typography variant='body2'>
                      {record.tags.map((tag, index) =>
                        <Chip
                          key={index}
                          label={tag}
                          className={classes.chip}
                          onClick={handleClickTag}
                          component={Link}
                          to={makePath(`/puzzle?tg=${encodeURIComponent(tag)}`, language)}
                        />
                      )}
                    </Typography>
                  </div>
                )}
              </React.Fragment>
            }
            customFooter={
              <React.Fragment>
                <CardActions style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                  <div style={{width: 'calc(100% - 56px)', display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
                    {user ? (
                      <React.Fragment>
                        <Button onClick={handleClickThumbUp} {...thumbUpButtonProp}>
                          <ThumbUpIcon className={classes.evaluationIcon}/>{record.goodNumber}
                        </Button>
                        <Button onClick={handleClickThumbDown} {...thumbDownButtonProp}>
                          <ThumbDownIcon className={classes.evaluationIcon}/>{record.badNumber}
                        </Button>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <ThumbUpIcon className={classes.thumbIcon}/>
                        <Typography className={classes.goodNumber} variant='body2'>{record.goodNumber}</Typography>
                        <ThumbDownIcon className={classes.thumbIcon}/>
                        <Typography className={classes.badNumber} variant='body2'>{record.badNumber}</Typography>
                      </React.Fragment>
                    )}
                    <Button disabled>
                      <CommentIcon className={classes.commentIcon}/>
                      <Typography variant='body2' className={classes.commentsLength}>{commentsLength}</Typography>
                    </Button>
                    <Button onClick={handleAnswer(record, bid)}>
                      <Word wid={WID.PUZZLE_VIEWER.ANSWER_BUTTON}/>
                    </Button>
                  </div>
                  <div>
                    <IconButton
                      className={classnames(classes.expand, {
                        [classes.expandOpen]: expanded,
                      })}
                      onClick={() => setExpanded(!expanded)}
                    >
                      <ExpandMoreIcon />
                    </IconButton>
                  </div>
                </CardActions>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                  <CardContent>
                    {record.comments &&
                      record.comments.length > 0 &&
                      record.comments[0].comment && (
                      <React.Fragment>
                        <Typography style={{fontWeight: 'bold', marginBottom: theme.spacing.unit / 2}}>
                          <Word wid={WID.PUZZLE_VIEWER.AUTHORS_COMMENT}/>
                        </Typography>
                        <div className={classes.commentBox}>
                          <Avatar
                            alt={record.comments[0].user.displayName}
                            src={record.comments[0].user.photoURL}
                            className={classes.commentAvatar}
                          />
                          <div style={{width: 'calc(100% - 48px)'}}>
                            <Typography style={{fontWeight: 'bold', color: theme.palette.grey[800]}} noWrap>{record.comments[0].user.displayName}</Typography>
                            <Typography>{record.comments[0].comment}</Typography>
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                    {user && (
                      <div className={classes.commentBox}>
                        <Avatar
                          alt={user.displayName}
                          src={user.photoURL}
                          className={classes.commentAvatar}
                        />
                        <div style={{width: '100%', textAlign: 'right'}}>
                          <TextField
                            className={classes.textField}
                            placeholder={getWord(WID.PUZZLE_VIEWER.ENTER_A_COMMENT, language)}
                            value={comment}
                            onChange={commentProps.handleTextChange('comment')}
                            fullWidth
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={isAppendedBoard}
                                onChange={commentProps.handleCheckboxChange('isAppendedBoard')}
                                color='primary'
                              />
                            }
                            label={<Word wid={WID.PUZZLE_VIEWER.ATTACHMENT_BOARD}/>}
                          />
                          <Button onClick={commentProps.handleClickComment(comment, isAppendedBoard, bid)}>
                            <Word wid={WID.PUZZLE_VIEWER.SEND_COMMENT_BUTTON}/>
                          </Button>
                        </div>
                      </div>
                    )}
                    {record.comments &&
                      record.comments.length > 1 &&
                      record.comments.slice(1, record.comments.length).map((comment, index) => {
                      var boardContext
                      if (comment.mv) {
                        boardContext = strToRenjuBoardCard({
                          v: 2,
                          md: 'p',
                          ...comment,
                        })
                      }
                      return (
                        <div key={index}>
                          <div className={classes.commentBox}>
                            <Avatar
                              alt={comment.user.displayName}
                              src={comment.user.photoURL}
                              className={classes.commentAvatar}
                            />
                            <div style={{width: 'calc(100% - 48px)'}}>
                              <div style={{display: 'flex', justifyContent: 'flex-start'}}>
                                <Typography style={{fontWeight: 'bold', color: theme.palette.grey[800]}} noWrap>{comment.user.displayName}</Typography>
                                {comment.dt && 
                                  <Typography style={{width: 100, color: theme.palette.grey[500]}}>・<TimeAgo date={comment.dt} formatter={formatter}/></Typography>
                                }
                              </div>
                              <Typography>{comment.comment}</Typography>
                              {boardContext &&
                                <ButtonBase onClick={commentProps.handleClickOpenBoard(index + 1, !comment.openBoard)}>
                                  {comment.openBoard ? (
                                    <Typography color='primary' style={{marginRight: theme.spacing.unit}}>
                                      <Word wid={WID.PUZZLE_VIEWER.RENJU_BOARD_BUTTON}/><ArrowDropUpIcon style={{fontSize: '1em'}}/>
                                    </Typography>
                                  ) : (
                                    <Typography color='primary' style={{marginRight: theme.spacing.unit}}>
                                      <Word wid={WID.PUZZLE_VIEWER.RENJU_BOARD_BUTTON}/><ArrowDropDownIcon style={{fontSize: '1em'}}/>
                                    </Typography>
                                  )}
                                </ButtonBase>                          
                              }
                              {comment.isAuthor && (
                                <ButtonBase onClick={confirmDialogProps.handleOpen('comment', { commentId: comment.id })}>
                                  <Typography color='primary'><Word wid={WID.PUZZLE_VIEWER.DELETE_COMMENT_BUTTON}/></Typography>
                                </ButtonBase>
                              )}
                              {boardContext && (
                                <Collapse in={comment.openBoard}>
                                  <ButtonBase onClick={commentProps.handleClickOpenBoard(index + 1, !comment.openBoard)}>
                                  <RenjuBoard
                                    moves={boardContext.moves}
                                    isVisibleNumber={true}
                                    isVisibleCoordinate={true}
                                  />
                                  </ButtonBase>
                                </Collapse>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    )}
                  </CardContent>
                </Collapse>
              </React.Fragment>
            }
          />
          <ControlCard bid={bid}/>
          </div>
        ) : ready === true ? (
          <div className={classes.flexCenterBox}>
            <Typography><Word wid={WID.PUZZLE_VIEWER.MESSAGE_DONT_FOUND_PUZZLE}/></Typography>
          </div>
        ) : (
          <div className={classes.flexCenterBox}>
            <CircularProgress/>
          </div>
        )}
      </Grid>
      <Dialog open={openConfirmDialog} onClose={confirmDialogProps.handleClose}>
        <DialogTitle><Word wid={WID.PUZZLE_VIEWER.DELETE_CONFIRM_DIALOG.DIALOG_TITLE}/></DialogTitle>
        <DialogActions>
          <Button
            onClick={
              (() => {
                if (confirmType === 'puzzle') {
                  return confirmDialogProps.handleDeletePuzzle(confirmParams)
                }
                else if (confirmType === 'comment') {
                  return confirmDialogProps.handleDeleteComment(confirmParams)
                }
              })()
            }
            color="primary">
            OK
          </Button>
          <Button onClick={confirmDialogProps.handleClose} color="primary">
            Canncel
          </Button>
        </DialogActions>
      </Dialog>
    </TitleGrid>
  )
}

export default withStyles(styles, { withTheme: true })(PuzzleViewer)



// WEBPACK FOOTER //
// ./src/Pages/Puzzle/components/PuzzleViewer.js